import i18n from 'i18n';

export const GUEST_WEIGHT_TYPES = {
  LBS: 'lbs',
  KG: 'kg',
};

export const GUEST_WEIGHT_TYPE_TO_LABEL_MAP = {
  [GUEST_WEIGHT_TYPES.LBS]: 'Lbs',
  [GUEST_WEIGHT_TYPES.KG]: 'Kgs',
};

export const getGuestWeightOptions = () =>
  Object.values(GUEST_WEIGHT_TYPES).map((key) => ({
    value: key,
    label: i18n.t(`proposal_content.guest_portal.guest_form.health_and_diet.input.weight_units.${key}`),
  }));
